import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: "Je n'ai vraiment pas le temps. Je suis seule avec mes enfants.",
  answer: 'Chaque exercice dans RE-NAISSANCE est conçu pour être complété en 5 à 15 minutes maximum. Tu peux commencer pendant que ton café chauffe. Ce système a été créé par et pour les mamans solo débordées.'
}, {
  question: 'Est-ce que ce guide va me parler de rencontres ou de séduction ?',
  answer: "Absolument pas. Zéro contenu de dating. Zéro pression de \"trouver quelqu'un\". Ce guide parle exclusivement de TOI — de ta confiance, ton style, ta paix intérieure. Tu dois d'abord te plaire à toi-même avant de plaire à qui que ce soit d'autre."
}, {
  question: "J'ai été mariée 20 ans. Est-ce que c'est trop tard pour moi ?",
  answer: "C'est précisément pour toi que ce système a été créé. Plus tu t'es oubliée longtemps, plus la renaissance est spectaculaire. Des femmes de 55 ans nous écrivent pour nous dire que c'est la première fois depuis 25 ans qu'elles se sentent \"entières\"."
}, {
  question: 'Est-ce que je reçois ça immédiatement ?',
  answer: 'Oui. Dans les 2 minutes qui suivent ton paiement, tu reçois un email avec tous tes guides en format PDF. Compatible mobile, tablette et ordinateur. Même à minuit. Même le dimanche.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-cream py-10 px-6 md:py-16" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <h2 className="font-playfair text-3xl md:text-4xl text-charcoal text-center mb-8" data-id="element-61">
          Questions Fréquentes
        </h2>

        <div className="space-y-4" data-id="element-62">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-63">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors" data-id="element-64">
                <span className={`font-semibold text-lg ${openIndex === index ? 'text-burgundy' : 'text-charcoal'}`} data-id="element-65">
                  ❓ {faq.question}
                </span>
                <ChevronDownIcon className={`flex-shrink-0 ml-4 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-66" />
              </button>

              <AnimatePresence data-id="element-67">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-68">
                    <div className="px-6 pb-4 text-charcoal leading-relaxed" data-id="element-69">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}